import React, { Component } from 'react'
import GoogleMap from 'google-map-react'
import { fitBounds } from 'google-map-react/utils';
import ErrorMap from './error'

export default class StreetViewMap extends Component {
  constructor (props) {
    super(props)

    this.map=null;
    this.maps=null;

  }

  componentWillReceiveProps(next){
    if(this.map){
      this.initStreetView(this.map, this.maps, next.lat, next.lng, this.props.checkresults)
    }
  }

  render () {
    const API_KEY = "AIzaSyCm1MEYAHjkfpE-ygYkVPp5-0YIYuD8rxs";
    var lat = parseFloat(this.props.lat)
    var lng = parseFloat(this.props.lng)
    let zoom = 15
    let center = {
      lat: parseFloat(lat), lng: parseFloat(lng),
    }

    let checkresults = this.props.checkresults

    return (
    	<div className="container">
        <GoogleMap
          resetBoundsOnResize={true}
          yesIWantToUseGoogleMapApiInternals={true}
          defaultCenter={center}
          defaultZoom={zoom}
          bootstrapURLKeys={{key: API_KEY}}
          onGoogleApiLoaded={({map, maps}) => this.initStreetView(map, maps, lat, lng, checkresults)} />
    	</div>
    )
  }

  initStreetView(map, maps, lat, lng, checkresults) {
		function processSVData(data, status) {
      if (status == 'OK')  {
        checkresults('ok')
        panorama.setPano(data.location.pano)
        panorama.setPov({
            heading: 265,
            pitch: 0
        });
        panorama.setVisible(true);
      }
      else{
        checkresults('zero')
      }
    }

    this.map=map;
    this.maps=maps;
    var astorPlace = {lat: lat, lng: lng};
    var panorama;

    panorama = map.getStreetView();
    panorama && panorama.setPosition && panorama.setPosition(astorPlace);

    var placeLocation = {lat: lat, lng: lng};
    var sv = new maps.StreetViewService();
    sv.getPanorama({location: placeLocation, radius: 50}, processSVData);


  }
}



// WEBPACK FOOTER //
// ./src/components/Maps/streetView.js